import { render, staticRenderFns } from "./SocialThemeWidget.html?vue&type=template&id=67d3754c&"
import script from "./SocialThemeWidget.vue?vue&type=script&lang=ts&"
export * from "./SocialThemeWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports